import { DataField, DataFieldType, DataClassification } from './DataModels';

/**
 * Make a boolean data field.
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeBooleanDataField(name: string, value: boolean): DataField {
  return {
    name: name,
    dataType: DataFieldType.Boolean,
    value: value,
    classification: DataClassification.SystemMetadata
  };
}

/**
 * Make a data field corresponding to the Aria Int64 data type. Note that
 * JavaScript doesn't actually support Int64 precision on large numbers.
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeInt64DataField(name: string, value: number): DataField {
  return {
    name: name,
    dataType: DataFieldType.Int64,
    value: value,
    classification: DataClassification.SystemMetadata
  };
}

/**
 * Make a double data field
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeDoubleDataField(name: string, value: number): DataField {
  return {
    name: name,
    dataType: DataFieldType.Double,
    value: value,
    classification: DataClassification.SystemMetadata
  };
}

/**
 * Make a string data field
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeStringDataField(name: string, value: string): DataField {
  return {
    name: name,
    dataType: DataFieldType.String,
    value: value,
    classification: DataClassification.SystemMetadata
  };
}

/**
 * Make a GUID data field
 * !!!WARNING: Only the 1DS Sink has support for Guid types.
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeGuidDataField(name: string, value: string): DataField {
  return {
    name: name,
    dataType: DataFieldType.Guid,
    value: value,
    classification: DataClassification.SystemMetadata
  };
}
